import { YANDEX_METRIKA_ID } from "src/constants/metrika";

/**
 * Модуль для отслеживания конверсий в Яндекс Метрике
 */

/**
 * Отправляет событие в Яндекс Метрику
 * @param eventName Название события
 * @param params Дополнительные параметры события
 */
export const trackEvent = (
  eventName: string,
  params?: Record<string, unknown>,
): void => {
  if (window.ym) {
    window.ym(YANDEX_METRIKA_ID, "reachGoal", eventName, params);
  } else {
    console.warn(`Не удалось отправить событие ${eventName} в Яндекс Метрику`);
  }
};

/**
 * Отслеживает ошибки в Яндекс Метрике
 * @param errorType Тип ошибки
 * @param errorDetails Детали ошибки
 */
export const trackError = (
  errorType: string,
  errorDetails?: Record<string, unknown>,
): void => {
  trackEvent(`error_${errorType}`, errorDetails);
};

/**
 * Отслеживает ошибки авторизации
 * @param errorType Тип ошибки авторизации
 * @param errorDetails Детали ошибки
 */
export const trackAuthError = (
  errorType: string,
  errorDetails?: Record<string, unknown>,
): void => {
  trackError(`auth_${errorType}`, errorDetails);
};

/**
 * Отслеживает ошибки регистрации
 * @param errorType Тип ошибки регистрации
 * @param errorDetails Детали ошибки
 */
export const trackRegistrationError = (
  errorType: string,
  errorDetails?: Record<string, unknown>,
): void => {
  trackError(`registration_${errorType}`, errorDetails);
};
